import { Badge } from '@/components/ui/badge';
import type { ConsiderationStatus } from '@rock/types';
import { assertUnreachable } from '@rock/util';
import type { FC } from 'react';

export const ConsiderationStatusBadge: FC<{ status: ConsiderationStatus | undefined; variant?: 'text' | 'badge' }> = ({
    status,
    variant = 'text',
}) => {
    if (!status) {
        return variant === 'badge' ? (
            <Badge variant="secondary">none</Badge>
        ) : (
            <span className="text-muted-foreground">none</span>
        );
    }

    if (variant === 'badge') {
        switch (status) {
            case 'pending':
                return <Badge variant="outline">pending</Badge>;
            case 'accepted':
                return <Badge className="bg-green-600">accepted</Badge>;
            case 'ignored':
                return <Badge variant="secondary">ignored</Badge>;
            // Not the homeowner's answer: the app took this one back when the home stopped matching it.
            case 'withdrawn':
                return <Badge variant="secondary">withdrawn</Badge>;
            default:
                assertUnreachable(status);
        }
    }

    switch (status) {
        case 'pending':
            return <span className="text-yellow-600 font-medium">pending</span>;
        case 'accepted':
            return <span className="text-green-600 font-medium">accepted</span>;
        case 'ignored':
            return <span className="text-red-600 font-medium">ignored</span>;
        case 'withdrawn':
            return <span className="text-muted-foreground font-medium">withdrawn</span>;
        default:
            assertUnreachable(status);
    }
};
